import { createContext } from 'react'

export const CurrentHotelContext = createContext({});
